import React, { Fragment, useEffect, useMemo, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import SelectComponent from "../../components/SelectComponent";
import InputComponent from "../../components/InputComponent";
import TitleH4Component from "../../components/TitleH4Component";
import LoaderComponent from "../../components/LoaderComponent";
import { getUsers } from "../../api/Users";
import { getClases } from "../../api/Clase";
import { getTipos } from "../../api/Tipo";
import {
  inventarioCM,
  inventarioNomina,
  inventarioStock,
  inventarioVR,
  inventarioAlquiler,
} from "../../api/Inventario";
import stylebtn from "../../styles/btn.module.scss";
import stylegeneral from "../../styles/general.module.scss";

const InventarioPage = () => {
  function obtenerFechaHoy() {
    return new Date().toISOString().split("T")[0];
  }

  // Estados de filtros
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedOptionClass, setSelectedOptionClass] = useState(null);
  const [selectedOptionType, setSelectedOptionType] = useState(null);
  const [formDataFecha, setFormDataFecha] = useState({
    fechaI: obtenerFechaHoy(),
    fechaFin: obtenerFechaHoy(),
  });

  // Estados de opciones para selects
  const [usuarios, setUsuarios] = useState([]);
  const [optionsclass, setOptionsClass] = useState([]);
  const [optionstype, setOptionstype] = useState([]);

  // Estados de datos del inventario
  const [datosVR, setDatosVR] = useState(null);
  const [datosStock, setDatosStock] = useState(null);
  console.log("Estos son los abonos", datosStock);
  const [dataCM, setDataCM] = useState(null);
  const [dataNominaE, setDataNominaE] = useState(null);
  const [dataAlquiler, setDataAlquiler] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const handleInputChangeFecha = (event) => {
    const { name, value } = event.target;
    setFormDataFecha((prev) => ({ ...prev, [name]: value }));
  };

  // ==========================================
  //            Opciones para Selects
  // =================Evita que se vuelva a ejecutar en cada render=========================
  const optionsUsuarios = useMemo(() => {
    if (!Array.isArray(usuarios)) return [];
    return usuarios.map((user) => ({
      value: user.id,
      label: user.nombre,
    }));
  }, [usuarios]);

  // ==========================================
  //            Cálculos
  // ==========================================
  const margenNetoGanancia =
    Number(datosVR?.utilidadAbonosVR ?? 0) +
    Number(datosVR?.utilidadContadoVR ?? 0) +
    Number(datosStock?.utilidadAbonoStock ?? 0) +
    Number(datosStock?.utilidadVentaStock ?? 0) +
    Number(datosVR?.totalSoloElaboracion ?? 0) +
    Number(dataAlquiler?.gananciaNetaAlquiler ?? 0);

  const dineroEnCaja =
    (Number(datosVR?.totalContadoVR ?? 0) +
    Number(datosVR?.totalAbonosVR ?? 0) +
    Number(datosStock?.totalVentaContadoStock ?? 0) +
    Number(datosStock?.totalAbonoStock ?? 0) +
    (dataNominaE?.totalAbono ?? 0) +
    Number(datosVR?.totalSoloElaboracion ?? 0) +
    Number(dataAlquiler?.gananciaNetaAlquiler ?? 0)) -
    (Number(dataNominaE?.totalNominaPagada ?? 0) +
      Number(dataNominaE?.totalAdelantos ?? 0) +
      Number(dataCM?.totalGastosCM ?? 0));

  const utilidadesTotales =
    margenNetoGanancia -
    Number(dataCM?.totalGastosCM ?? 0) -
    Number(dataNominaE?.totalCostoDia ?? 0);

  // Calcular cantidad total de ventas
  const cantidadTotalVentas =
    Number(datosStock?.cantidadVentasStock) + Number(datosVR?.cantidadVentasVR);

  // ==========================================
  //      Funciones de Carga de Datos
  // ==========================================
  const cargarInventario = async () => {
    try {
      setLoading(true);

      const filtroFecha = {
        fechaInicio: formDataFecha.fechaI,
        fechaFin: formDataFecha.fechaFin,
      };

      if (selectedUser) {
        filtroFecha.usuario = selectedUser;
      }

      if (selectedOptionClass) {
        filtroFecha.idClase = selectedOptionClass;
      }

      if (selectedOptionType) {
        filtroFecha.idTipo = selectedOptionType;
      }

      const [vr, nomina, stock, cajaMenor, alquiler] = await Promise.all([
        inventarioVR(filtroFecha),
        inventarioNomina(filtroFecha),
        inventarioStock(filtroFecha),
        inventarioCM(filtroFecha),
        inventarioAlquiler(filtroFecha),
      ]);

      setDatosVR(vr);
      setDataNominaE(nomina);
      setDatosStock(stock);
      setDataCM(cajaMenor);
      setDataAlquiler(alquiler);
    } catch (error) {
      console.error("Error cargando inventario:", error);
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  //            Effects
  // ==========================================

  // Cargar usuarios al montar
  useEffect(() => {
    const cargarUsuarios = async () => {
      try {
        const response = await getUsers();
        setUsuarios(response.data);
      } catch (error) {
        console.error("Error cargando usuarios", error);
        setUsuarios([]);
      }
    };
    cargarUsuarios();
  }, []);

  // Cargar clases al montar
  useEffect(() => {
    getClases()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionsClass(formattedOptions);
      })
      .catch((error) => {
        console.error("Error cargando clases:", error);
      });
  }, []);

  // Cargar tipos al montar
  useEffect(() => {
    getTipos()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionstype(formattedOptions);
      })
      .catch((error) => {
        console.error("Error cargando tipos:", error);
      });
  }, []);

  // Recargar inventario cuando cambian los filtros
  useEffect(() => {
    cargarInventario();
  }, [
    formDataFecha.fechaI,
    formDataFecha.fechaFin,
    selectedUser,
    selectedOptionClass,
    selectedOptionType,
  ]);

  // ==========================================
  //            Render
  // ==========================================
  return (
    <Fragment>
      <HeaderComponent styleGroup="">
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          INVENTARIO
        </TitleH2Component>
      </HeaderComponent>

      <div className="conatiner-global pt-3 mb-5">
        <div className="container">
          {/* Filtros */}
          <div className="row gy-4">
            <div className="row gy-2 justify-content-end">
              <div className="col-12 col-md-4 col-xl-2">
                <InputComponent
                  label="Fecha Inicio:"
                  styleLabel="fw600 WorkSans"
                  type="date"
                  name="fechaI"
                  value={formDataFecha.fechaI}
                  onChange={handleInputChangeFecha}
                />
              </div>

              <div className="col-12 col-md-4 col-xl-2">
                <InputComponent
                  label="Fecha Final:"
                  styleLabel="fw600 WorkSans"
                  type="date"
                  name="fechaFin"
                  value={formDataFecha.fechaFin}
                  onChange={handleInputChangeFecha}
                />
              </div>

              <div className="col-12 col-md-4 col-xl-2 d-flex justify-content-start">
                <button
                  type="button"
                  onClick={cargarInventario}
                  className={`${stylebtn.btn} ${stylebtn.primary} mt-4`}
                >
                  CALCULAR
                </button>
              </div>
            </div>
            <div className="row gy-2 justify-content-center">
              <div className="col-12 col-md-4 col-xl-4">
                <SelectComponent
                  styleLabel="color-madera fw600"
                  label="Usuario"
                  customPlaceholder="Selecionar.."
                  options={optionsUsuarios}
                  capOpcions={setSelectedUser}
                  isClearable={true}
                />
              </div>

              <div className="col-12 col-md-4 col-xl-4">
                <SelectComponent
                  styleLabel="color-madera fw600"
                  label="Clase de madera"
                  customPlaceholder="Selecionar.."
                  options={optionsclass}
                  name="clase"
                  value={selectedOptionClass}
                  capOpcions={setSelectedOptionClass}
                  isClearable
                />
              </div>

              <div className="col-12 col-md-4 col-xl-4">
                <SelectComponent
                  styleLabel="color-madera"
                  label="Tipo de madera"
                  customPlaceholder="Selecionar.."
                  options={optionstype}
                  name="tipo"
                  value={selectedOptionType}
                  capOpcions={setSelectedOptionType}
                  isClearable
                />
              </div>
            </div>
          </div>

          {/* Resultados */}
          <div className="d-flex justify-content-center">
            {loading ? (
              <LoaderComponent styleGroup="mt-5" />
            ) : (
              <div
                className={`${stylegeneral.cuadro_inventario} mt-5 py-2 px-1 w-100`}
              >
                {/* Ventas Realizadas */}
                <TitleH4Component
                  styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton color-inventario"
                >
                  <span>Ventas realizadas/Modificadas</span>
                  <span style={{color:"green"}}># {cantidadTotalVentas}</span>
                </TitleH4Component>
                {/* Ventas Rápidas */}
                <TitleH4Component                  
                  styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton"
                >
                  <span>Totales de Ventas Rápidas</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.totalContadoVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>20% de las Ventas rápidas</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.utilidadContadoVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component
                  styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton"
                >
                  <span>Abonos a facturas Ventas Rápidas</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.totalAbonosVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>20% de Abonos a facturas Ventas Rápidas</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.utilidadAbonosVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Ganancia en calle VR</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.gananciaEnCalleVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Total utilidad abonos VR</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.totalUtilidadAVR || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component
                  styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton"
                >
                  <span>Total Elaboraciones de madera</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.totalSoloElaboracion || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Elaboraciones pendientes de pago</span>
                  <span>
                    ${" "}
                    {Number(datosVR?.pendienteElaboracion || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                {/* Ventas Stockeadas */}
                <TitleH4Component
                  styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton"
                >
                  <span>Totales de Ventas stockeadas</span>
                  <span>
                    ${" "}
                    {Number(
                      datosStock?.totalVentaContadoStock || 0,
                    ).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Inversión de compras stockeadas</span>
                  <span>
                    ${" "}
                    {Number(
                      datosStock?.totalInversionStock || 0,
                    ).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Margen de ganancia Ventas stockeadas</span>
                  <span
                    style={{
                      color:
                        datosStock?.utilidadVentaStock < 0 ? "red" : "inherit",
                    }}
                  >
                    ${" "}
                    {Number(datosStock?.utilidadVentaStock || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component
                  styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton"
                >
                  <span>Abonos a facturas Stockeadas</span>
                  <span>
                    ${" "}
                    {Number(datosStock?.totalAbonoStock ?? 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Inversión de compras Abono facturas Stockeadas</span>
                  <span>
                    ${" "}
                    {Number(
                      datosStock?.totalInversionFinanciado || 0,
                    ).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Utilidades de Abonos facturas Stockeadas</span>
                  <span
                    style={{
                      color:
                        datosStock?.utilidadAbonoStock < 0 ? "red" : "black",
                    }}
                  >
                    ${" "}
                    {Number(datosStock?.utilidadAbonoStock || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                {/* El alquiler no consume inventario (el material se devuelve), así
                que todo lo cobrado por devoluciones es ganancia neta, sin costo
                de mercancía que restar. */}
                <TitleH4Component styleGroup="color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Ganancia neta - Alquiler</span>
                  <span>
                    ${" "}
                    {Number(dataAlquiler?.gananciaNetaAlquiler || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                {/* Totales Generales */}
                <TitleH4Component styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Total financiado</span>
                  <span>
                    ${" "}
                    {(
                      Number(datosVR?.pendientePorCobrarVR || 0) +
                      Number(datosStock?.totalPendientePagoStock || 0)
                    ).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Descuentos aplicados</span>
                  <span>
                    ${" "}
                    {(
                      Number(datosVR?.totalDescuentoVR || 0) +
                      Number(datosStock?.totalDescuentoStock || 0)
                    ).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Caja menor</span>
                  <span>
                    ${" "}
                    {Number(dataCM?.totalGastosCM || 0).toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                {/* Nómina */}
                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Nómina de empleados</span>
                  <span>
                    ${" "}
                    {Number(dataNominaE?.totalCostoDia || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Pago de nómina</span>
                  <span>
                    ${" "}
                    {Number(dataNominaE?.totalNominaPagada || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>
                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Adelantos de nóminas</span>
                  <span>
                    ${" "}
                    {Number(dataNominaE?.totalAdelantos || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Abonos de los empleados</span>
                  <span>
                    ${" "}
                    {Number(dataNominaE?.totalAbono || 0).toLocaleString(
                      "es-ES",
                    )}
                  </span>
                </TitleH4Component>

                {/* Resultados Finales */}
                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Margen neto de ganancias por ventas</span>
                  <span
                    style={{
                      color: margenNetoGanancia < 0 ? "red" : "inherit",
                    }}
                  >
                    $ {margenNetoGanancia.toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Dinero en caja</span>
                  <span style={{color:"green"}}>$ {(dineroEnCaja || 0).toLocaleString("es-ES")}</span>
                </TitleH4Component>

                <TitleH4Component styleGroup="color-dark color-inventario fw400 WorkSans fw700 d-flex justify-content-between align-items-center px-1 border-botton">
                  <span>Total utilidades</span>
                  <span
                    style={{
                      color: utilidadesTotales < 0 ? "red" : "black",
                    }}
                  >
                    $ {utilidadesTotales.toLocaleString("es-ES")}
                  </span>
                </TitleH4Component>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default InventarioPage;
